import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptorService implements HttpInterceptor {

  constructor(private snackbar: MatSnackBar) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          const isAuth = err.url.indexOf('oauth') > -1;
          if (!isAuth && err instanceof HttpErrorResponse && err.status !== 401 && err.status !== 409) {
            const message = (err.error && err.error.detail) || err.statusText;
            this.snackbar.open(message, 'Close', {
              // duration: 5000,
              panelClass: 'snackbar-error'
            });
          }
          throw err;
        })
      );
  }
}
